import { useGT } from 'gt-react';
import { Badge } from 'src/components/ui/badge';

// The counts an override panel header carries, the same on the lead-time and
// inventory-policy panels: how many overrides apply right now, and how many of
// those are past their review date and waiting on a buyer. The review count
// mirrors the tab counts on the override browser (/procurement/demand-forecasting/overrides).

export function OverrideCountBadges({
  activeCount = 0,
  overrideCount,
  needsReviewCount,
}: {
  activeCount?: number;
  overrideCount?: number;
  needsReviewCount: number;
}) {
  const gt = useGT();
  return (
    <div className="flex items-center gap-1">
      {overrideCount !== undefined && overrideCount > 0 ? (
        <Badge variant="secondary">
          {gt('{n} overrides', {
            context: 'procurement saved live override count',
            n: overrideCount,
          })}
        </Badge>
      ) : null}
      {activeCount > 0 ? (
        <Badge variant="secondary">
          {gt('{n} active', {
            context: 'procurement override active count badge',
            n: activeCount,
          })}
        </Badge>
      ) : null}
      {needsReviewCount > 0 ? (
        <Badge variant="secondary" className="bg-orange-100 text-orange-700">
          {gt('{n} need review', {
            context: 'procurement override needs-review count badge',
            n: needsReviewCount,
          })}
        </Badge>
      ) : null}
    </div>
  );
}
